<template lang="html">
	<div class="rs-times">
		<h5 class="rs-business-hours">Öffnungszeiten</h5>
		<div 
			v-for="(day, index) in daysOfWeek" 
			:key="day.day" 
			class="rs-time-day d-block d-sm-none">
			<span class="day-name">{{ day.name }}:</span>
			<span 
				class="rs-time-badge" 
				v-if="day.times.length>0" 
				v-for="hour in day.times" 
				:key="hour.id">
				{{ hour.open }} bis {{ hour.close }}
			</span>
			<span 
				v-if="day.times.length===0" 
				class="rs-time-badge">geschlossen</span>
		</div>
		<div class="rs-table-container d-none d-sm-block">
			<table class="rs-table table table-sm">
				<thead>
					<tr>
						<th 
							v-for="(day, index) in daysOfWeek" 
							v-if="day.times.length>0">{{ day.name }}</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td 
							v-for="(day, index) in daysOfWeek" 
							v-if="day.times.length>0">
							<div 
								v-for="(time, timeIndex) in day.times" 
								class="rs-time">
								<div>{{ time.open }}</div>
								<div>{{ time.close }}</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import moment from 'moment'

export default {
	name: 'BusinessHours',
	props: {
		businessHours: { type: Array, default: () => [] },
		weekDay: Number
	},
	computed: {
		daysOfWeek() {
			const days = []
			for (let i = 0; i < 7; i++) {
				const day = moment().weekday(i)
				const times = this.businessHours
					.filter(h => h.day === day.day())
					.map(h => Object.assign({}, h))
					.sort((a, b) => parseInt(a.open) - parseInt(b.open))
				days.push({
					name: day.format('dddd'),
					day: day.day(),
					times
				})
			}
			return days
		}
	}
}
</script>

<style lang="css" scoped>
.rs-table-container {
	display: block;
	width: 100%;
	overflow-x: auto;
}
.rs-time-badge {
	border-radius: 8px;
	background-color: #222;
	margin-right: 0.3em;
	color: #fff;
	font-size: .7em;
	padding: 3px 5px;
}
.rs-time {
	text-align: center;
	color: #fff;
	background-color: #000;
	padding: 7px;
	width: 65px;
	border-radius: 8px;
	margin: auto;
	margin-bottom: 5px;
	font-size: 0.9em;
	overflow: hidden;
}
.rs-business-hours {
	font-weight: bold;
}
.rs-table{
	background-color: transparent;
}
th {
	font-size: 0.8em;
}
.rs-table td {
	text-align: center;
	padding: 0.3rem;
}
</style>
